export default {
  getCurrentGeolocation(state) {
    return (
      state.currentGeolocation ||
      JSON.parse(localStorage.getItem("currentGeolocation") || "") ||
      {}
    );
  },
};
